import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-collective-buying',
  templateUrl: './collective-buying.component.html',
  styleUrls: ['./collective-buying.component.scss']
})
export class CollectiveBuyingComponent implements OnInit {

  constructor(
    private router: Router
  ) {
    let status = localStorage.getItem('has_onboarded')
    if (status == 'false') {
      this.router.navigate(['/onboarding'])
    }
    else {
      return
    }
  }

  ngOnInit() {
  }

}
